import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { AcademicYear } from "src/app/models/academic-year";
import { EduClass } from "src/app/models/edu-class";
import { EduTerm } from "src/app/models/edu-term";
import { Student } from "src/app/models/student";
import { DefaultApiService } from "src/app/shared/services/default-api.service";
import { environment } from "src/environments/environment.prod";

@Component({
  selector: "app-creche-remarks",
  templateUrl: "./creche-remarks.component.html",
  styleUrls: ["./creche-remarks.component.css"],
})
export class CrecheRemarksComponent implements OnInit {
  basicData;
  loading = false;
  academicYears: AcademicYear[] = [];
  terms: EduTerm[] = [];
  students: Student[] = [];
  classes: EduClass[] = [];

  printResultsForm = new FormGroup({
    academicYear: new FormControl(""),
    term: new FormControl(""),
    className : new FormControl(""), 
    student: new FormControl(""),
  });

  constructor(private defaultApi: DefaultApiService) {}

  ngOnInit() {
    this.getBasicData();
    this.getAcademicYears();
    // this.getStudents();
  }

  onClassSelected(event : Event){
     const selectedClassId = (event.target as HTMLSelectElement).value;
     this.students = this.classes.filter((classes: any) => {
          return classes.id == selectedClassId;
        })[0].students;
  }

  getAcademicYears() {
    this.loading = true;
    this.defaultApi.getAll("api/v1/academic-years").subscribe(
      (response: any) => {
        console.log(response);
        this.academicYears = response.data.academicYears;
        this.terms = response.data.terms;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        console.error("Error fetching academic years:", error);
        // Handle the error appropriately, e.g., show a notification or log it
      }
    );
  }

  getStudents() {
    this.loading = true;
    this.defaultApi.getAll("api/v1/students-in-creche").subscribe(
      (response: any) => {
        this.loading = false;
        console.log("response", response);
        this.students = response;
      },
      (error) => {
        this.loading = false;
        console.log("error", error);
      }
    );
  }

  getBasicData() {
    this.defaultApi.getAll("api/v1/enter-class-marks/get-basic-data").subscribe(
      (response: any) => {
        console.log(response);

        this.basicData = response.data;

        this.loading = false;

        this.classes = response.data.classes;
      },
      (error) => {
        this.loading = false;
        console.error("Error fetching basic data:", error);
        // Handle the error appropriately, e.g., show a notification or log it
      }
    );
  }

  onRefresh() {
    // Logic to refresh the creche remarks data
    console.log("Creche remarks refreshed");
  }

  onSubmitPrintResultsForm(event: Event) {
    event.preventDefault();
    // Logic to handle form submission for printing results

    this.printResults(this.printResultsForm.value);
  }

  printResults(data) {
    this.loading = true;
    console.log("Form submitted for printing results", data);
    const baseUrl = environment.base_url + "/api/v1/print-creche-reports";
    const year = data.academicYear;
    const term = data.term;
    const className = data.className; // Use empty string instead of null
    const student = data.student ? data.student : null; // Use empty string instead of null

    const url = `${baseUrl}/${year}/${term}/${className}/${student}`;
    console.log("Opening URL:", url);

    window.open(url, "_blank");
  }

  printClassResults() {
    // Logic to print class results
    console.log("Printing class results");
  }

  printStudentsResults() {
    // Logic to print students results
    console.log("Printing students results");
  }
}
